import * as React from "react";
import type { SVGProps } from "react";
const SvgStripeLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#6772E5" d="M0 0h264v264H0z" />
    <g clipPath="url(#stripe-logo-icon_svg__a)">
      <path
        fill="#fff"
        d="M47.845 122.99c0-2.125 1.75-2.943 4.651-2.943 4.159 0 9.412 1.254 13.571 3.488v-12.806c-4.542-1.798-9.029-2.506-13.57-2.506-11.11 0-18.497 5.776-18.497 15.421 0 15.04 20.794 12.642 20.794 19.127 0 2.506-2.188 3.324-5.253 3.324-4.542 0-10.342-1.853-14.94-4.359v12.969c5.09 2.179 10.234 3.106 14.94 3.106 11.382 0 19.208-5.613 19.208-15.367-.055-16.239-20.904-13.351-20.904-19.454m36.992-25.666-13.352 2.834-.055 43.648c0 8.065 6.074 14.005 14.173 14.005 4.487 0 7.77-.818 9.576-1.799v-11.061c-1.75.708-10.397 3.215-10.397-4.85v-19.345H95.18v-11.607H84.782zm27.361 15.857-.875-4.032h-11.82v47.681h13.68v-32.314c3.228-4.196 8.701-3.433 10.397-2.834v-12.533c-1.751-.654-8.153-1.853-11.382 4.032m14.72-4.032h13.736v47.681h-13.736zm0-4.141 13.736-2.943V91.003l-13.736 2.888zm42.301 3.215c-5.363 0-8.811 2.506-10.726 4.25l-.712-3.378h-12.038v63.537l13.68-2.888.055-15.421c1.97 1.417 4.87 3.433 9.686 3.433 9.795 0 18.715-7.847 18.715-25.121-.055-15.803-9.084-24.412-18.66-24.412m-3.284 37.545c-3.228 0-5.144-1.144-6.457-2.561l-.055-20.217c1.423-1.58 3.393-2.67 6.512-2.67 4.98 0 8.427 5.558 8.427 12.697 0 7.302-3.392 12.751-8.427 12.751M231 133.18c0-13.95-6.786-24.957-19.755-24.957-13.024 0-20.904 11.008-20.904 24.848 0 16.402 9.303 24.685 22.655 24.685 6.512 0 11.437-1.471 15.158-3.542v-10.898c-3.72 1.853-7.989 2.997-13.407 2.997-5.308 0-10.014-1.853-10.616-8.283h26.76c0-.709.109-3.542.109-4.85m-27.033-5.177c0-6.157 3.776-8.718 7.224-8.718 3.338 0 6.895 2.561 6.895 8.718z"
      />
    </g>
    <defs>
      <clipPath id="stripe-logo-icon_svg__a">
        <path fill="#fff" d="M34 91h197v82H34z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStripeLogoIcon;
